import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const RespirationLogPage = lazy(() => import("./RespirationLogPage.tsx"));

const RespirationLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <RespirationLogPage />
    </Suspense>
  );
};

export default RespirationLogPageLazy;
